import { AddressJSON } from "_shared/addresses/address-schema";
import MarketplaceResponseAPIResponse from "marketplace/_api/response-contracts/marketplace-response-api-response";
import CompanyProfile from "marketplace/companies/profiles/company-profile";

import MarketplaceIndividualInfoAPIResponse from "marketplace/individuals/profiles/_api/response-contracts/marketplace-individual-info-api-response";

export default class MarketplaceCompanyInfoAPIResponse extends MarketplaceResponseAPIResponse {
  public name?: string;
  public yearEstablished?: number;
  public numberOfEmployees?: number;
  public contact?: MarketplaceIndividualInfoAPIResponse;
  public description?: string;
  public location?: AddressJSON;
  public website?: string;
  public avatar?: string;
  public categories?: string[];

  public deserializeToProfile(): CompanyProfile | null | undefined {
    const id = this.id;
    if (!id) throw new Error("Company ID is required, was not returned by the API");
    if (!this.name) throw new Error("Name is required, was not returned by the API");
    return CompanyProfile.fromJSON(this);
  }
}
